/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import {
  Badge,
  Button, Col, Modal, Row,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import validateForm from 'utils/Validator';
import useSubmit from 'hooks/useSubmit';
import { yupChangePassword } from 'utils/yupFields';
import { Invitation } from 'types/Invitation';
import moment from 'moment';
import { getNdaStatusName, parseNdaMetadata } from 'utils/utils';
import AdminInvitationsServices from 'services/api/AdminInvitations';
import iconDownload from 'assets/img/icons/download.svg';
import { EventCategoryType, EventProps } from 'types/Event';
import { IoCallOutline } from 'react-icons/io5';
import { FiMapPin } from 'react-icons/fi';
import classNames from 'classnames';

type EventDetailModalProps = {
  data?: EventProps,
  onClose: () => void,
};

function EventDetailModal( {
  data, onClose,
}: EventDetailModalProps ) {
  const { t } = useTranslation();

  // const ndaArray = parseNdaMetadata( data?.ndaMetadata );
  return (
    <Modal
      show
      // className="modal-carousel"
      centered
      size="lg"
      onHide={onClose}
    >
      <Modal.Header className="pb-0" closeButton />
      <Modal.Body className="pt-0">
        <Row>
          <Col md={11} className="m-auto">
            <h3 className="text-center mb-4">{data?.titulo}</h3>
            <div>
              <h4 className="bg-light p-2 rounded">General:</h4>
              <Row className="mt-3 px-3">
                <Col sm={3}>
                  Descripción:
                </Col>
                <Col>
                  {data?.descripcion || '-'}
                </Col>
              </Row>
              <Row className="mt-3 px-3">
                <Col sm={3}>
                  Proyecto:
                </Col>
                <Col>
                  {data?.promocion || '-'}
                </Col>
              </Row>
              <Row className="mt-3 px-3">
                <Col sm={3}>
                  Fecha de inicio:
                </Col>
                <Col sm={4}>
                  {data?.allDate ? `${moment.utc( data?.fechaInicio ).local().format( 'dddd, MMMM DD' )} - Todo el día`
                    : moment.utc( data?.fechaInicio ).local().format( 'dddd, MMMM DD - HH:mm' )}
                </Col>
              </Row>
              {!data?.allDate && (
                <Row className="mt-3 px-3">
                  <Col sm={3}>
                    Fecha de fin:
                  </Col>
                  <Col sm={4}>
                    {moment.utc( data?.fechaFin ).local().format( 'dddd, MMMM DD - HH:mm' )}
                  </Col>
                </Row>
              )}

              <Row className="mt-3 px-3">
                <Col sm={3}>
                  Encuentro:
                </Col>
                <Col>
                  <Row className="gx-2">
                    {( data?.categoria === EventCategoryType.hibrid
                    || data?.categoria === EventCategoryType.online ) && (
                      <Col xs="auto">
                        <Badge className="d-flex align-items-center">
                          <IoCallOutline className="me-2" />
                          Teams
                        </Badge>
                      </Col>
                    )}
                    {( data?.categoria === EventCategoryType.hibrid
                    || data?.categoria === EventCategoryType.inPerson ) && (
                    <Col xs="auto">
                      <Badge className="d-flex align-items-center">
                        <FiMapPin className="me-2" />
                        En persona
                      </Badge>
                    </Col>
                    )}
                  </Row>

                </Col>
              </Row>

              {data?.direccion
              && (
              <Row className="mt-3 px-3">
                <Col sm={3}>
                  Dirección:
                </Col>
                <Col sm={4}>
                  {data?.direccion}
                </Col>
              </Row>
              )}

              <h4 className="mt-4 bg-light p-2 rounded">Archivos:</h4>
              <div className="mt-3 px-3">
                {data?.ficheros?.map( ( file ) => (
                  <div className="mb-1" key={file.id}>
                    <a
                      className="btn btn-link text--semibold p-0 mb-1 text--md w-100 text-ellipsis text-start"
                      target="_blank"
                      href={file.url}
                      rel="noreferrer"

                    >
                      {file.nombre}
                    </a>
                  </div>
                ) )}
                {!data?.ficheros?.length && <span>No hay datos disponibles</span>}
              </div>

            </div>
            {/* <Row>
              <Col className="mt-5">
                <Button
                  variant="primary"
                  type="button"
                  className="btn--full-width"
                  disabled
                >
                  {t( 'admin.common.closeInvitation' )}
                </Button>
              </Col>
            </Row> */}

          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default EventDetailModal;
